import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { GridColDef } from "@mui/x-data-grid";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import { NewUserRole } from "../../../../store/newProfile/types";
import { RequestStatus } from "../../../Enum";

interface EndUserColumnsProps {
  profileRole: NewUserRole;
}

export function EndUserColumns({
  profileRole,
}: EndUserColumnsProps): GridColDef[] {
  return [
    {
      field: "action",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderHeader: () => <b>Action</b>,
      renderCell: (params) => {
        if (
          profileRole.roleId === "RL230000002" &&
          (params.row.requestStatus === RequestStatus.Draft ||
            params.row.requestStatus === RequestStatus.Pending)
        ) {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Link
                to={`/edit/${params.row.requestID}`}
                style={{ width: "30px" }}
              >
                <EditOutlinedIcon className="pencilAction" />
              </Link>

              <Link
                to={`/view/${params.row.requestID}`}
                style={{ width: "30px" }}
              >
                <SearchOutlinedIcon className="black" />
              </Link>
            </div>
          );
        }

        if (profileRole.roleId === "RL230000002") {
          return (
            <Link to={`/view/${params.row.requestID}`}>
              <SearchOutlinedIcon className="black" />
            </Link>
          );
        }

        return "";
      },
    },
    {
      field: "requestStatus",
      width: 150,
      renderHeader: () => <b>Request Status</b>,
      renderCell: (params) => {
        if (
          profileRole.roleId === "RL230000002" &&
          (params.row.requestStatus === RequestStatus.Draft ||
            params.row.requestStatus === RequestStatus.Pending)
        ) {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Link
                style={{ color: "#6C2882" }}
                to={`/edit/${params.row.requestID}`}
              >
                {params.row.requestStatus === RequestStatus.SendBack
                  ? RequestStatus.AwaitingConfirmation
                  : params.row.requestStatus}
              </Link>
            </div>
          );
        }

        if (profileRole.roleId === "RL230000002") {
          return (
            <Link
              style={{ color: "#6C2882" }}
              to={`/view/${params.row.requestID}`}
            >
              {params.row.requestStatus === RequestStatus.SendBack
                ? RequestStatus.AwaitingConfirmation
                : params.row.requestStatus}
            </Link>
          );
        }

        return "";
      },
    },
    {
      field: "requestNumber",
      width: 220,
      renderHeader: () => <b>Request No.</b>,
    },
    {
      field: "requestDate",
      width: 180,
      renderHeader: () => <b>Request Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.requestDate}</Moment>
        </div>
      ),
    },
    { field: "noCRR", width: 170, renderHeader: () => <b>CRR No.</b> },
    {
      field: "counterpart",
      width: 250,
      renderHeader: () => <b>Counterpart</b>,
      renderCell: (params) => <div>{params.row.counterpart}</div>,
    },
    {
      field: "requestType",
      width: 150,
      renderHeader: () => <b>Request Type</b>,
      renderCell: (params) => <div>{params.row.requestType}</div>,
    },
    {
      field: "documentType",
      width: 150,
      renderHeader: () => <b>Document Type</b>,
      renderCell: (params) => <div>{params.row.documentType}</div>,
    },
    {
      field: "poaDate",
      width: 180,
      renderHeader: () => <b>POA Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.poaDate}</Moment>
        </div>
      ),
    },
    {
      field: "noPOA",
      width: 250,
      renderHeader: () => <b>POA No.</b>,
      renderCell: (params) => (
        <div>
          {params.row.noPOA}
          <br />
          {params.row.noSubstitution}
        </div>
      ),
    },
  ];
}
